function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n          background-color: ", ";\n        "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n          background-color: ", ";\n        "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n          background-color: ", ";\n        "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    border-radius: 50%;\n    display: flex;\n    padding: ", ";\n    ", ";\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    & > path {\n      fill: ", ";\n    }\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import React from "react";
import styled, { css } from "styled-components";
import { Icon as BaseIcon } from "@diana-ui/icon";
import { Registry } from "@cf-design-system/registry";
var StyledIcon = styled(BaseIcon)((_ref) => {
  var {
    fill
  } = _ref;
  return css(_templateObject(), fill);
});
export var Frame = styled.div((_ref2) => {
  var {
    theme,
    frameColor
  } = _ref2;
  return css(_templateObject2(), theme.spaceUnit.xxs, !frameColor ? css(_templateObject3(), theme.colors.white) : frameColor === "alt" ? css(_templateObject4(), theme.colors.grey.grey25) : css(_templateObject5(), frameColor));
});

var Icon = (_ref3) => {
  var {
    frameClassName,
    frameColor,
    hasFrame = false
  } = _ref3,
      props = _objectWithoutProperties(_ref3, ["frameClassName", "frameColor", "hasFrame"]);

  return hasFrame ? /*#__PURE__*/React.createElement(Frame, {
    className: frameClassName,
    frameColor: frameColor
  }, /*#__PURE__*/React.createElement(StyledIcon, props)) : /*#__PURE__*/React.createElement(StyledIcon, props);
};

Registry.register(Icon, "Icon");
export default Icon;